export default "__VITE_ASSET__Ta4v8fFl__"